import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'generateStarData',
  standalone: true,
})
export class GenerateStarDataPipe implements PipeTransform {
  transform(stars: number): unknown[] {
    if(!stars) {
      return [];
    }
    return new Array(+stars);
  }
}
